import {
  appendHelpText,
  applyTextAreaLengthValidation,
  createControlLabel,
  createFieldScaffold,
  createTextArea,
} from "../shared.ts";
import type { RenderContext, RenderField } from "../types.ts";
import { renderTextLikeField } from "./text-input.ts";

export const renderTextField = (
  field: RenderField<"TEXT">,
  context: RenderContext,
): HTMLElement => {
  if (field.configJson?.multiline) {
    return renderMultilineTextField(field, context);
  }

  return renderTextLikeField(field, context, "text");
};

const renderMultilineTextField = (
  field: RenderField<"TEXT">,
  context: RenderContext,
): HTMLElement => {
  const scaffold = createFieldScaffold(field, context);
  const label = createControlLabel(field.label, field.required, scaffold.inputId);
  const textarea = createTextArea(field, scaffold.inputId, scaffold.helpId);

  applyTextAreaLengthValidation(textarea, field);

  scaffold.wrapper.append(label, textarea);
  appendHelpText(scaffold, field);

  return scaffold.wrapper;
};
